// extracted by mini-css-extract-plugin
export var box = "CaptchaInfo-module--box--1ca33";
export var box_md = "CaptchaInfo-module--box_md--f8ae3";
export var box_xmd = "CaptchaInfo-module--box_xmd--6c242";
export var box_flex = "CaptchaInfo-module--box_flex--da9ca";
export var box_lg = "CaptchaInfo-module--box_lg--738b1";
export var box_sm = "CaptchaInfo-module--box_sm--93d01";
export var box_outer = "CaptchaInfo-module--box_outer--acfef";
export var box_whiteBg = "CaptchaInfo-module--box_white-bg--71c8d";
export var box_noMarginBottom = "CaptchaInfo-module--box_no-margin-bottom--abcbd";
export var box_noPadding = "CaptchaInfo-module--box_no-padding--31422";
export var box_outerGray = "CaptchaInfo-module--box_outer-gray--450f1";
export var box_dark = "CaptchaInfo-module--box_dark--17dec";
export var box_zIndex = "CaptchaInfo-module--box_z-index--f1897";
export var box_zIndex6 = "CaptchaInfo-module--box_z-index-6--f2f71";
export var box_eventsWithLine = "CaptchaInfo-module--box_events-with-line--ea71a";
export var box_featuresAo = "CaptchaInfo-module--box_features-ao--ea77d";
export var box_verticalPaddings = "CaptchaInfo-module--box_vertical-paddings--931a9";
export var clearP = "CaptchaInfo-module--clearP--0b881";
export var clearP_vc = "CaptchaInfo-module--clearP_vc--5cdb0";
export var captcha = "CaptchaInfo-module--captcha--65253";
export var white = "CaptchaInfo-module--white--03c69";
export var fintech = "CaptchaInfo-module--fintech--89aa8";
export var text = "CaptchaInfo-module--text--939aa";
export var owlSoul = "CaptchaInfo-module--owlSoul--a7518";
export var bishkek = "CaptchaInfo-module--bishkek--20625";
export var london = "CaptchaInfo-module--london--01a1c";
export var tooltip = "CaptchaInfo-module--tooltip--9f037";
export var error = "CaptchaInfo-module--error--00d1c";
export var fadeInAnimation = "CaptchaInfo-module--fadeInAnimation--47397";
export var placeHolderShimmer = "CaptchaInfo-module--placeHolderShimmer--ab71a";